import React from 'react'

const CloseIcon16 = ({ className }) => (
  <svg className={className} height='16' width='16'>
    <path d='m2.61289944 1.20970461.09420734.08318861 5.29289322 5.29210678 5.2928932-5.29210678c.3905243-.39052429 1.0236893-.39052429 1.4142136 0 .3604839.36048396.3882135.92771502.0831886 1.32000622l-.0831886.09420734-5.2921068 5.29289322 5.2921068 5.2928932c.3905243.3905243.3905243 1.0236893 0 1.4142136-.360484.3604839-.927715.3882135-1.3200062.0831886l-.0942074-.0831886-5.2928932-5.2921068-5.29289322 5.2921068c-.39052429.3905243-1.02368927.3905243-1.41421356 0-.36048396-.360484-.3882135-.927715-.08318861-1.3200062l.08318861-.0942074 5.29210678-5.2928932-5.29210678-5.29289322c-.39052429-.39052429-.39052429-1.02368927 0-1.41421356.36048396-.36048396.92771502-.3882135 1.32000622-.08318861z' />
  </svg>
)

export default CloseIcon16
